import type { Device } from 'src/types/Device';
import { get_gen_2_component_channel_structure } from './interface_helpers';

export function hasComponentConfigKeyInSettings(
	device: Device,
	deviceSettings: Record<string, unknown> | undefined,
	configKey: string,
): boolean {
	const componentPath = get_gen_2_component_channel_structure(device);
	const block = deviceSettings?.[componentPath];
	if (block == null || typeof block !== 'object') {
		return false;
	}
	return Object.hasOwn(block, configKey);
}
